// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2d612f03","455":"56332153","977":"8e758b60"}[chunkId] + ".chunk.js";
};